import React from "react";

const GOLD = "#c9a227";
const SUPPORT_EMAIL = "tatvak@theresetsanctuary.org";

const Refund = () => {
    return (
        <main
            data-testid="refund-page"
            style={{
                backgroundColor: "#0a0a0a",
                color: "#ddd",
                minHeight: "100vh",
                padding: "120px 24px 80px",
            }}
        >
            <div style={{ maxWidth: 760, margin: "0 auto" }}>
                <p
                    className="eyebrow"
                    style={{
                        color: GOLD,
                        fontSize: 11,
                        letterSpacing: "0.32em",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        margin: "0 0 16px",
                    }}
                >
                    The Reset Sanctuary
                </p>
                <h1
                    className="font-serif"
                    style={{
                        fontSize: "clamp(36px, 5vw, 56px)",
                        fontWeight: 400,
                        color: "#fff",
                        margin: "0 0 14px",
                        lineHeight: 1.1,
                        letterSpacing: "-0.02em",
                    }}
                >
                    Refund &amp; Reschedule Policy
                </h1>
                <p style={{ color: "#888", fontSize: 13, letterSpacing: "0.08em", margin: "0 0 56px" }}>
                    Last updated: February 2026
                </p>

                <section style={{ marginBottom: 40, lineHeight: 1.8, fontSize: 15, fontWeight: 300 }}>
                    <h2 className="font-serif" style={{ color: "#fff", fontSize: 24, fontWeight: 400, margin: "0 0 16px" }}>
                        How It Works
                    </h2>
                    <p style={{ margin: "0 0 14px" }}>
                        Every Sleep &amp; Anxiety Broadcast is a live, hand-produced session. Lossless audio architecture, real-time delivery, finite seats. Because each broadcast is created and delivered live by Tatva K personally, our policy is built around <span style={{ color: GOLD }}>rescheduling, not refunds</span>.
                    </p>
                    <p style={{ margin: 0 }}>
                        If life gets in the way, we&rsquo;ll move you. If we drop the ball technically, we&rsquo;ll refund. Simple.
                    </p>
                </section>

                <section style={{ marginBottom: 40, lineHeight: 1.8, fontSize: 15, fontWeight: 300 }}>
                    <h2 className="font-serif" style={{ color: "#fff", fontSize: 24, fontWeight: 400, margin: "0 0 16px" }}>
                        Single Session ($29.99)
                    </h2>
                    <ul style={{ paddingLeft: 18, margin: 0 }}>
                        <li style={{ marginBottom: 10 }}>
                            <span style={{ color: "#fff" }}>No refunds</span> on confirmed live sessions. Seats are reserved against a live, time-bound broadcast.
                        </li>
                        <li style={{ marginBottom: 10 }}>
                            <span style={{ color: GOLD }}>Free reschedule</span> to the next available Block A or Block B if you can&rsquo;t make it &mdash; just email us before the session starts.
                        </li>
                        <li style={{ marginBottom: 10 }}>
                            <span style={{ color: GOLD }}>Full refund</span> only if the session is cancelled by us, or if a verified technical failure on our end (Zoom outage, broadcast not delivered) prevents the session from happening.
                        </li>
                    </ul>
                </section>

                <section style={{ marginBottom: 40, lineHeight: 1.8, fontSize: 15, fontWeight: 300 }}>
                    <h2 className="font-serif" style={{ color: "#fff", fontSize: 24, fontWeight: 400, margin: "0 0 16px" }}>
                        5-Seat Bundle ($99)
                    </h2>
                    <ul style={{ paddingLeft: 18, margin: 0 }}>
                        <li style={{ marginBottom: 10 }}>
                            Bundle seats <span style={{ color: GOLD }}>never expire</span> and can be gifted or transferred to anyone.
                        </li>
                        <li style={{ marginBottom: 10 }}>
                            <span style={{ color: "#fff" }}>No refunds</span> on purchased bundles, but unused seats can be rescheduled indefinitely.
                        </li>
                        <li style={{ marginBottom: 10 }}>
                            If a technical failure on our end prevents a redeemed seat from delivering, that specific seat is refunded or replaced &mdash; your call.
                        </li>
                    </ul>
                </section>

                <section style={{ marginBottom: 40, lineHeight: 1.8, fontSize: 15, fontWeight: 300 }}>
                    <h2 className="font-serif" style={{ color: "#fff", fontSize: 24, fontWeight: 400, margin: "0 0 16px" }}>
                        Unlimited Membership ($79 / month)
                    </h2>
                    <ul style={{ paddingLeft: 18, margin: 0 }}>
                        <li style={{ marginBottom: 10 }}>
                            <span style={{ color: GOLD }}>Cancel anytime.</span> Cancellation stops all future billing immediately &mdash; no retention friction, no exit survey.
                        </li>
                        <li style={{ marginBottom: 10 }}>
                            Already-charged months are <span style={{ color: "#fff" }}>non-refundable</span> and are not pro-rated. You retain full access until the end of the paid period.
                        </li>
                        <li style={{ marginBottom: 10 }}>
                            No reactivation fees if you come back later.
                        </li>
                    </ul>
                </section>

                <section style={{ marginBottom: 40, lineHeight: 1.8, fontSize: 15, fontWeight: 300 }}>
                    <h2 className="font-serif" style={{ color: "#fff", fontSize: 24, fontWeight: 400, margin: "0 0 16px" }}>
                        How to Reschedule or Request a Refund
                    </h2>
                    <p style={{ margin: "0 0 14px" }}>
                        Email{" "}
                        <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: GOLD, textDecoration: "underline" }} data-testid="refund-support-email">
                            {SUPPORT_EMAIL}
                        </a>{" "}
                        with the email address you used to book and the date of your session. We&rsquo;ll respond within 24 hours.
                    </p>
                    <p style={{ margin: 0 }}>
                        Approved refunds are processed via Stripe within 5&ndash;7 business days back to the original payment method.
                    </p>
                </section>

                <section style={{ marginBottom: 0, lineHeight: 1.8, fontSize: 15, fontWeight: 300 }}>
                    <h2 className="font-serif" style={{ color: "#fff", fontSize: 24, fontWeight: 400, margin: "0 0 16px" }}>
                        Chargebacks &amp; Disputes
                    </h2>
                    <p style={{ margin: "0 0 14px" }}>
                        Please email us before initiating a chargeback. If your case qualifies under this policy we will resolve it directly &mdash; faster than your bank can dispute.
                    </p>
                    <p style={{ margin: 0, color: "#888", fontSize: 13, paddingTop: 24, borderTop: "1px solid rgba(201,162,39,0.1)" }}>
                        Questions? Email{" "}
                        <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: GOLD }}>
                            {SUPPORT_EMAIL}
                        </a>
                        .
                    </p>
                </section>
            </div>
        </main>
    );
};

export default Refund;
